import { useEffect } from "react";

/**
 * Public payment cancelled page. Rendered at /cancelled (Stripe checkout cancel_url).
 */
export default function PaymentCancelled() {
  useEffect(() => {
    document.title = "Payment cancelled — Ratezy";
  }, []);
  return (
    <>
      <style>{`
        :root { --bg:#07080a; --surface:#0f1113; --border:rgba(255,255,255,0.09);
                --text:#f4f4f5; --muted:#a1a1aa; }
        html,body,#root { background:var(--bg); color:var(--text);
          font-family:'Inter', system-ui, sans-serif; margin:0; min-height:100vh; }
        .pc-body { min-height:100vh; display:flex; align-items:center; justify-content:center; padding:24px; }
        .pc-card { background:var(--surface); border:1px solid var(--border); border-radius:24px;
          max-width:520px; width:100%; padding:44px 36px; text-align:center; }
        .pc-card h1 { font-family:'Space Grotesk', sans-serif; font-size:1.8rem; margin:0 0 12px; letter-spacing:-0.02em; }
        .pc-card p { color:var(--muted); font-size:1rem; line-height:1.6; margin:0 0 18px; }
        .pc-brand { display:inline-flex; align-items:center; gap:8px; margin-top:24px;
          color:var(--muted); font-size:0.85rem; }
        .pc-brand img { height:20px; width:auto; }
      `}</style>
      <div className="pc-body" data-testid="payment-cancelled-page">
        <main className="pc-card">
          <h1>Payment cancelled</h1>
          <p>No worries — nothing has been charged. If you'd like to complete your Ratezy subscription later, use the same payment link from your email.</p>
          <div className="pc-brand"><img src="/ratezy-logo.webp" alt="Ratezy" /></div>
        </main>
      </div>
    </>
  );
}
